import PlatformSwitcher from "@/components/PlatformSwitcher/PlatformSwitcher.vue";

export default {
  name: "SidebarUserFooter",

  components: {
    PlatformSwitcher
  },

  props: {
    initials: {
      type: String,
      required: true
    },
    full_name: {
      type: String,
      required: true
    },
    is_admin: {
      type: Boolean,
      default: false
    }
  }
};
